$(function () {
  $.validator.addMethod(
    'tel_number',
     function (value, element) {
      if (this.optional(element)) {
          return true
      }
      return this.optional(element) || /\d{2,5}[-(]\d{1,4}[-)]\d{4}/.test(value)
      },
      'Please enter in the format 03-1234-5678'
   )
  $('#contact-form').validate({
    rules: {
      company_name: {
        required: true,
      },
      your_name: {
        required: true,
      },
      your_kana: {
        required: true,
      },
      your_tel: {
        required: true,
        tel_number: true,
      },
      your_mail: {
        required: true,
        email: true,
      },
      your_message: {
        required: true,
      },
    },
    messages: {
      company_name: {
        required: '会社名を入力してください',
      },
      your_name: {
        required: 'お名前を入力してください',
      },
      your_kana: {
        required: 'ふりがなを入力してください',
      },
      your_tel: {
        required: '電話番号を入力してください',
        tel_number: '03-1234-5678 の形式で入力してください',
      },
      your_mail: {
        required: 'メールアドレスを入力してください',
        email: '有効なメールアドレスを入力してください',
      },
      your_message: {
        required: '問い合わせ内容を入力してください',
      },
    },
    errorPlacement: function (error, element) {
      error.insertAfter(element)  // バリデーションボックスの直後
    },
  })
})
